import React from "react";
import { QuizPuzzle } from "~/shared/components/QuizPuzzle";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import img from "~/shared/assets/images/32/rabochiy_i_kolhoznitsa.jpg";

const Theme32Task2 = () => {
  return (
    <QuizWrapper
      title='ПАЗЛ'
      icon='puzzle'
      successIcon='rus-1'
      subtitle='Собери памятник Рабочему и колхознице.'
      description='перетащи элементы пазла на соответствующие места.'
    >
      <QuizPuzzle img={img} />
    </QuizWrapper>
  );
};

export default Theme32Task2;
